import React from 'react';
import Menu from '../common/menu';
import Footer from '../common/footer';
import HeroServices from './hero-services';
import GroundTransport from '../general/ground-transport';
import WhyChooseUs from '../general/why-choose-us';
import { Helmet } from "react-helmet-async";

function MainServices() {
  return (
    <div className="content-wrapper">
      <Helmet>
        <link rel="canonical" href="https://www.businessclasschauffeur.com.au/service" />
      </Helmet>
      <Menu /> 
      <HeroServices />
      <GroundTransport />
      <WhyChooseUs />
      <Footer />
    </div>
  );
}

export default MainServices;